import { useState } from 'react';
import { IIconName } from 'v2/resources/types/icon';
import { IMenuItem } from '../types';
import { useHistory } from 'react-router-dom';

//TODO: REFACTOR IN UPDATE REACT
const useMenu = () => {
  const navigate = useHistory();
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpandedMenu = () => {
    setIsExpanded((prevState) => !prevState);
  };

  const menuItems: Array<IMenuItem> = [
    {
      id: 'config',
      label: 'Configurações',
      icon: 'SettingsSuggestOutlined',
      onClick: () => navigate.push('/settings-ai'),
    },
    {
      id: 'new-chat',
      label: 'Novo Chat',
      icon: 'RateReviewOutlined',
      onClick: () => console.log('Novo Chat clicked'),
    },
    {
      id: 'search-chat',
      label: 'Buscar Chat',
      icon: 'SearchOutlined',
      onClick: () => console.log('Buscar Chat clicked'),
    },
  ];

  return { isExpanded, menuItems, toggleExpandedMenu };
};

export default useMenu;
